
import { computed, defineComponent } from 'vue';
import { useWhatsappOnboardingWizard } from '@/composables/whatsapp/useWhatsappOnboardingWizard';
import type { OnboardingPath } from '@/types/whatsapp-onboarding';
import WhatsappOnboardingNav from './WhatsappOnboardingNav.vue';
import WhatsappOnboardingProgress from './WhatsappOnboardingProgress.vue';
import IntroStep from './steps/IntroStep.vue';
import SituationStep from './steps/SituationStep.vue';
import NumberChoiceStep from './steps/NumberChoiceStep.vue';
import AccessChecklistStep from './steps/AccessChecklistStep.vue';
import MetaTipsStep from './steps/MetaTipsStep.vue';
import MigrationPrepStep from './steps/MigrationPrepStep.vue';
import MigrationWarningStep from './steps/MigrationWarningStep.vue';

export default defineComponent({
  name: 'WhatsappOnboardingWizard',

  components: {
    WhatsappOnboardingNav,
    WhatsappOnboardingProgress,
    IntroStep,
    SituationStep,
    NumberChoiceStep,
    AccessChecklistStep,
    MetaTipsStep,
    MigrationPrepStep,
    MigrationWarningStep,
  },

  props: {
    shopId: {
      type: Number,
      required: true,
    },
    connectLoading: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['connect'],

  setup(props) {
    const wizard = useWhatsappOnboardingWizard(props.shopId);

    const showNextButton = computed(() => (
      wizard.isIntroStep.value
      || (!wizard.isConnectStep.value && !wizard.isLastStep.value)
    ));

    const onPathSelected = (value: OnboardingPath) => {
      wizard.setPath(value);
    };

    const handleNext = () => {
      if (wizard.isIntroStep.value) {
        wizard.goNext();
        return;
      }
      wizard.goNext();
    };

    return {
      wizard,
      showNextButton,
      onPathSelected,
      handleNext,
    };
  },
});
